var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 344 144 C 340.08 196.87 300 240 256 240 C 212 240 171.85 196.88 168 144 C 164 89 203 48 256 48 C 309 48 348 90 344 144 Z",
    stroke: "black",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 256 304 C 169 304 80.7 352 64.36 442.6 C 62.39 453.52 68.57 464 80 464 L 432 464 C 443.44 464 449.62 453.52 447.65 442.6 C 431.3 352 343 304 256 304 Z",
    stroke: "black",
    strokeWidth: 50,
    strokeMiterlimit: 10,
    fill: "none"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.93660fb34a67946a1d5df430ba86f57e.svg";
export { ForwardRef as ReactComponent };